import  gql  from 'graphql-tag'

export const CREATE_IDENTIFICATION_DOCUMENT_TYPE = gql`mutation identificationDocumentType($input: IdentificationDocumentTypeMutationInput!){
    identificationDocumentType(input: $input){
        identificationDocumentType{
            id
            code
            name
            isActive
        }
        errors{
            field
            messages
        }
    }
}`;